import { render, staticRenderFns } from "./SystemRole.vue?vue&type=template&id=1d0a82d0&"
import script from "./SystemRole.vue?vue&type=script&lang=js&"
export * from "./SystemRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports